<button class="lx-btn lx-btn-text"
        [disabled]="disabled"
        (click)="shareLink()">
  <i class="lx-icon lx-share"></i>
  Share
</button>